import { ref, type Ref } from 'vue'
import { defineStore } from 'pinia'
import type { IncidentType } from '@/models/IncidentType'

export const useIncidentTypeStore = defineStore(
  'incident_types',
  () => {
    const incidentTypes: Ref<IncidentType[]> = ref([])
    const getData = () => incidentTypes.value
    const setData = (data: IncidentType[]) => (incidentTypes.value = data)

    const findByCode = (code: string) => {
      return incidentTypes.value.find((type) => type.code === code) || null
    }

    return {
      incidentTypes,
      getData,
      setData,
      findByCode,
    }
  },
  {
    persist: true,
  },
)
